import React, { useState } from 'react'
import { DMAutomation } from '../../types/automations/dmAutomationTypes'
import InsufficientPermissionsCTA from '../CTA/InsufficientPermissions';
import { ERROR } from '../../constants/errors';
import { POSTAPIError } from '../../types';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux-stores/store';
import AutomationInsights from './AutomationInsights';
import AddLink from './AddLink';

interface AllLinkedPostsProps {
    dmAutomations: DMAutomation[]
}

const AllLinkedPosts: React.FC<AllLinkedPostsProps> = ({ dmAutomations }) => {

    const [selectedLinkForInsights, setSelectedLinkForInsights] = useState<string | null>(null);
    const [selectedLinkForEdit, setSelectedLinkForEdit] = useState<DMAutomation | null>(null);

    const loading = useSelector((state: RootState) => state.dmAutomations.loading);


    const [APIError, setAPIError] = useState<POSTAPIError | null>(null);


    return (
        <div>
            {
                APIError && APIError.error_code === ERROR.INSUFFICIENT_PERMISSIONS && APIError.missing_permissions &&
                <div className="m-3">
                    <InsufficientPermissionsCTA missing_permissions={APIError.missing_permissions} feature={APIError.feature} />
                </div>
            }
            <h4 className="pop mx-3 mb-3">Linked Posts</h4>
            {
                dmAutomations.length > 0 &&

                <div className="card card-style mx-3">
                    <table className="table table-hover">
                        <thead>
                            <tr className='posts-table-row align-middle'>
                                <th className='text-center'>Post</th>
                                <th className='text-center'>Status</th>
                                <th className='text-center'>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                dmAutomations.map((automation, i) => {
                                    return (
                                        <tr className='posts-table-row text-center align-middle' key={i} onClick={() => setSelectedLinkForInsights(automation.social_post.uuid)}>
                                            <td>
                                                <span className='p-1 cursor-pointer posts-table-action-icon font-16 me-2' onClick={(e) => {
                                                    e.stopPropagation();
                                                    setSelectedLinkForEdit(automation)
                                                }}>
                                                    <i className='fa-solid fa-edit'></i>
                                                </span>
                                                <img src={automation.social_post.thumbnail_url} className="rounded-2 post-thumbnail-sm" alt="feed" />
                                            </td>
                                            <td>
                                                {
                                                    automation.status === 'active' &&
                                                    <span className='linked-badge-sm text-success'>Linked</span>
                                                }
                                                {
                                                    automation.status === 'inactive' &&
                                                    <span className='inactive-badge-sm text-danger'>Inactive</span>
                                                }
                                            </td>
                                            <td>
                                                <button className='rounded-sm view-insights-cta'>View Insights</button>
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
            }
            {
                dmAutomations.length === 0 && !loading &&
                <div className="card h-full card-style rounded-card mx-3">
                    <div className="card-body">
                        <div className="h-200px d-flex justify-content-center align-items-center text-center">
                            <div className='px-5'>
                                <h2 className="pop">You have not linked any post yet!</h2>
                            </div>
                        </div>
                    </div>
                </div>
            }
            <AutomationInsights
                isActive={!!selectedLinkForInsights}
                onClose={() => setSelectedLinkForInsights(null)}
                postId={selectedLinkForInsights}
                onError={(error) => setAPIError(error)}
            />
            <AddLink
                isActive={!!selectedLinkForEdit}
                onClose={() => setSelectedLinkForEdit(null)}
                post={selectedLinkForEdit?.social_post!}
                onError={(error) => {
                    setSelectedLinkForEdit(null)
                    setAPIError(error)
                }}
                dmAutomation={selectedLinkForEdit}
            />
        </div>
    )
}

export default AllLinkedPosts